import React from 'react'
import {
    List,
    Edit,
    DateField,
    ReferenceField,
    BooleanField,
    SimpleForm,
    NumberField,
    Datagrid,
    TextField,
    Show,
} from 'react-admin'

export const transactionTransactionBagShow = ({ ...props }) => (
    <Show {...props}>
        <SimpleForm>
            <TextField source="id" />
        </SimpleForm>
    </Show>
)

export const transactionTransactionBagList = (props: any) => {
    return (
        <List {...props}>
            <Datagrid rowClick="edit">
                <TextField source="id" />
                <DateField source="created" />
                <ReferenceField
                    source="transactionId"
                    reference="transaction/transaction"
                >
                    <TextField source="id" />
                </ReferenceField>{' '}
            </Datagrid>
        </List>
    )
}
